// src/components/LoginForm.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../actions/authAction';  
import { useNavigate } from 'react-router-dom';
import { getSurah, getReviewSurahsSummary } from '../actions/appAction';

function LoginForm() {
  const dispatch = useDispatch();
  const {error, isAuthenticated} = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const errorTranslations = {
    "No active account found with the given credentials":
    "البريد الالكتروني او كلمة المرور غير صحيحة",
  }

  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const { email, password } = credentials;

  // State for showing/hiding the password
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    if (!error) return;
    let msg = '';
    if (Array.isArray(error)) {
      msg = error[0] || '';
    } else if (typeof error === 'string') {
      msg = error;
    }
    // Only update the serverError here
    setErrorMessage(errorTranslations[msg] ?? msg);
  })

  const onChange = (e) =>
    setCredentials({ ...credentials, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getSurah());
      dispatch(getReviewSurahsSummary());
      navigate('/home');
    }
  }, [isAuthenticated, dispatch, navigate]);
  

  return (
    <div>
      <h2 className='title'>تسجيل دخول</h2>
      {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

      <form onSubmit={onSubmit}>
        <div>
          <label>البريد الالكتروني:</label>
          <input
            name="email"
            value={email}
            onChange={onChange}
          />
        </div>

        <div>
          <label>الرمز</label>
          <div className="password-wrapper">
            <input
              className="password-field"
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={onChange}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? 'اخفاء' : 'اظهار'}
            </button>
          </div>

          <a href="/forget-password" className="forget-password">نسيت الرمز؟</a>
        </div>

        <button type="submit" className="submit-button">دخول</button>
      </form>
    </div>
  );
}

export default LoginForm;
